import { MessageCircle } from "lucide-react";

const PHONE = "923707851120";
const MESSAGE = "Hello Trendora Marts, I need help with my order.";

export function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-white border border-border pl-2 pr-5 py-2 shadow-elegant hover:shadow-[0_10px_30px_-8px_rgba(31,181,181,0.55)] hover:border-[--teal] transition-all"
    >
      <span className="h-10 w-10 grid place-items-center rounded-full bg-[#25D366] text-white shrink-0 group-hover:scale-105 transition-transform">
        <MessageCircle className="h-5 w-5" />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-widest text-muted-foreground">WhatsApp</span>
        <span className="text-sm font-semibold text-[--navy]">Chat With Us</span>
      </span>
    </a>
  );
}
